import $ from 'jquery';
$(function () {
    var ua = window.navigator.userAgent;
    var isIE = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
    if (isIE) {
        //disable default bootstrap functionality
        $('#team-grid .grid-flow-col-normal').each(function (ind, elem) {
            $(elem).css('order', ind);
            $(elem).find('.focus-teaser').removeAttr('data-toggle')
        });
        $('#team-grid .grid-flow-col-full').each(function (ind, elem) {
            $(elem).css('order', (Math.floor(ind / 4) + 1) * 4);
        })
        $('#team-grid .focus-teaser').on('click', function (jqevt) {
            var trigger = $(jqevt.currentTarget);
            var target = $(trigger.attr('href'));
            $('#team-grid .grid-flow-col-full').each(function (ind, elem) {
                $(elem).toggleClass('show', $(elem).attr('id') == target.attr('id') && !$(elem).hasClass('show'));
            })
            jqevt.stopImmediatePropagation();
            return false;
        })
    }
});